// extracted by mini-css-extract-plugin
export default {"profile":"SideBarProfile_profile__sP+Yw","light":"SideBarProfile_light__Wmi8j","dark":"SideBarProfile_dark__6Jaxz"};